import ModalsSlice from "./reducers";
import {
  getIsModalOpen,
  getModalData,
  getIsSaveProgressModal,
  getIsReportModal,
  getIsVersionModal,
  getIsConfirmActionModal,
  getIsNewProjectModal,
  getIsEditProjectModal,
  getIsPointCloudModal,
  getIsGeoJsonSelectTypeModal,
  getIsVerifySemanticMapModal,
  getIsVerifyGeoJsonModal,
  getIsIntersectionsModal,
  getIsStopSignModal,
} from "./selectors";
import {
  SAVE_PROGRESS_MODAL,
  REPORT_MODAL,
  VERSION_MODAL,
  CONFIRM_ACTION_MODAL,
  VERIFY_GEOJSON_MODAL,
  VERIFY_SEMANTIC_MAP_MODAL,
  INTERSECTIONS_MODAL,
  GEO_JSON_SELECT_TYPE_MODAL,
  POINT_CLOUD_MODAL,
  EDIT_PROJECT_MODAL,
  NEW_PROJECT_MODAL,
  STOP_SIGN_MODAL,
  STATION_MODAL,
} from "./constants";
import { RootState } from "../../index";

//constants
export {
  SAVE_PROGRESS_MODAL,
  REPORT_MODAL,
  VERSION_MODAL,
  CONFIRM_ACTION_MODAL,
  VERIFY_GEOJSON_MODAL,
  VERIFY_SEMANTIC_MAP_MODAL,
  INTERSECTIONS_MODAL,
  GEO_JSON_SELECT_TYPE_MODAL,
  POINT_CLOUD_MODAL,
  EDIT_PROJECT_MODAL,
  NEW_PROJECT_MODAL,
  STOP_SIGN_MODAL,
  STATION_MODAL,
};

// actions
export const { toggleModal, closeAnyModal } = ModalsSlice.actions;

// selectors
export {
  getIsModalOpen,
  getModalData,
  getIsSaveProgressModal,
  getIsReportModal,
  getIsVersionModal,
  getIsConfirmActionModal,
  getIsNewProjectModal,
  getIsEditProjectModal,
  getIsPointCloudModal,
  getIsGeoJsonSelectTypeModal,
  getIsVerifySemanticMapModal,
  getIsVerifyGeoJsonModal,
  getIsIntersectionsModal,
  getIsStopSignModal,
};

export const getIsStationModal = (state: RootState) =>
  state.modals.type === STATION_MODAL;

// reducer
export default ModalsSlice.reducer;
